import { useNavigate, useRouterState } from "@tanstack/react-router";
import { Button } from "@/components/common";

export function ForbiddenPage() {
  const navigate = useNavigate();
  const search = useRouterState({
    select: (s) => s.location.search as { from?: string },
  });
  const from = search.from;

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 py-16">
      <p className="mb-2 text-sm font-medium tracking-widest text-adara-500 uppercase">
        Błąd
      </p>

      <h1 className="mb-3 text-7xl font-bold text-adara-900">403</h1>

      <p className="mb-2 max-w-md text-center text-dim">
        Nie masz uprawnień, aby wyświetlić tę stronę.
      </p>

      {from ? (
        <p className="mb-8 text-sm text-faint">
          Odmowa dostępu do:{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">
            {from}
          </code>
        </p>
      ) : (
        <div className="mb-8" />
      )}

      <div className="flex gap-3">
        <Button
          variant="primary"
          onClick={() => {
            void navigate({ to: "/" });
          }}
        >
          Strona główna
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            window.history.back();
          }}
        >
          Wróć
        </Button>
      </div>

      <div className="mt-12">
        <img
          src="/logos/adara-logo.svg"
          alt="Adara"
          className="h-8 opacity-30"
        />
      </div>
    </div>
  );
}
